export default __webpack_public_path__ + "static/PMG_EGTB_MYRUMAH_CW_AGENCY_BM-3fe73253761be48451c1f71d2fb72b95.pdf";